import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, InjectionToken, Injector, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import {
  AppRoutingModule, BeforeLoginRoutingComponents,
  DeviceRoutingComponents,
  EnergyRoutingComponents,
  HelpRoutingComponents,
  OrderRoutingComponents,
  PackageRoutingComponents,
  PaymentRoutingComponents,
  PlanRoutingComponents,
  StatusRoutingComponents
} from './app-routing.module';
import {
  IndexRoutingComponents,
  DetailRoutingComponents,
  EventsRoutingComponents,
  AlertsRoutingComponents,
  AboutRoutingComponents,
  LicenseRoutingComponents,
  AdminRoutingComponents
} from './app-routing.module';

import { ADirective } from './a.directive';
import { ShareModule } from './modules/share/share.module';
import { UserModule } from './modules/user/user.module';
// import { JwtModule } from '@auth0/angular-jwt';
import { environment, isODM } from '../environments/environment';
import { StartupService } from './services/startup.service';
import { AppConfigService } from './services/app-config.service';
import { WINDOW_PROVIDERS } from './window.provider';

// for NgRx/store
import * as fromStore from './store';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { AuthGuard } from './auth.guard';
import { ModuleModule } from './my-features/module/module.module';
import { NodeModule } from './my-features/node/node.module';
import { UpdateInfoModule } from './my-features/updateInfo/update-info.module';
import { RegionModule } from './my-features/region/region.module';
import { MessageService } from 'primeng/api';
import { NgxUiLoaderModule, NgxUiLoaderConfig, SPINNER, POSITION } from 'ngx-ui-loader';
import { StatusModule } from './my-features/status/status.module';
import { AccountModule } from './modules/account/account.module';
import { AutoLogoutService } from './services/auto-logout-service.service';
import { FloorMapModule } from './my-features/floor-map/floor-map.module';
import { ChangeInfoModule } from './my-features/change-info/change-info.module';
import { PurchaseModule } from './my-features/purchase/purchase.module';
import * as allAccount from './my-features/account/account.module';
import { LicenseMgtModule } from './my-features/license-mgt/license-mgt.module';
import { DeviceModule } from './my-features/device/device.module';
import { DeviceMgtModule } from './my-features/device-mgt/device-mgt.module';
import { CheckLicenseModule } from './my-features/check-license/check-license.module';
import { ActivateLicenseModule } from './my-features/activate-license/activate-license.module';
import { StopLicenseModule } from './my-features/stop-license/stop-license.module';
import { FirmWareModule } from './my-features/firm-ware/firm-ware.module';
import { PrivacyAndTermsModule } from './my-features/privacy-and-terms/privacy-and-terms.module';
import { EventMonitoringModule } from './my-features/event-monitoring/event-monitoring.module';
import { DeviceMonitoringModule } from './my-features/device-monitoring/device-monitoring.module';
import { BatteryTestModule } from './my-features/battery-test/battery-test.module';
import { BatteryReplacementModule } from './my-features/battery-replacement/battery-replacement.module';
import { PlanModule } from './my-features/plan/plan.module';
import { WorldMapModule } from './my-features/world-map/world-map.module';
import { BindDeviceModule } from './my-features/bind-device/bind-device.module';
import { ActivateTrialLicenseModule } from './my-features/activate-trial-license/activate-trial-license.module';
import { NotificationModule } from './my-features/notification/notification.module';
import { ContactUsModule } from './my-features/contact-us/contact-us.module';
import { AzureBlobStorageModule } from './my-features/azure-blob-storage/azure-blob-storage.module';
import { DeviceSharingModule } from './my-features/object-sharing/device-sharing.module';
import { UserActivityLogModule } from './my-features/user-activity-log/user-activity-log.module';
import { AppDownloadModule } from './my-features/app-download/app-download.module';
import { PriceModule } from './my-features/price/price.module';
import { SummaryModule } from './my-features/summary/summary.module';
import { OauthModule } from './my-features/account/oauth.module';
import { AuthOTPModule } from './my-features/account/auth-otp.module';
import { DeviceResetModule } from './my-features/device-reset/device-reset.module';
import { SystemlogModule } from './my-features/systemlog/systemlog.module';
import { CompanionModule } from './my-features/companion/companion.module';
import { CompanionRuleModule } from './my-features/companion/companion-rule.module';
import { DeviceSettingModule } from './my-features/device-setting/device-setting.module';
import { GroupSharingModule } from './my-features/object-sharing/group-sharing.module';
import { ApiKeyModule } from './my-features/api-key/api-key.module';
import { GateWayModule } from './my-features/gateway/gateway.module';
import { ProModule } from './my-features/pro/pro.module';
import { SmartPowerReportModule } from './my-features/smart-power-report/smart-power-report.module';
import { MailModule } from './my-features/mail/mail.module';
import { DeviceUPSControlModule } from './my-features/device-ups-control/device-ups-control.module';
import { EventMapModule } from './my-features/event-map/event-map.module';
import { HardwareModule } from './my-features/hardware/hardware.module';

// Others
import { clearState } from './store/clearStates';
import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
  TranslateLoader,
  TranslateModule, TranslateService
} from '@ngx-translate/core';
import { TranslateHttpLoader, TRANSLATE_HTTP_LOADER_CONFIG } from '@ngx-translate/http-loader';
import { LanguageService, STORE_KEY } from './services/language.service';
import { LOCATION_INITIALIZED } from '@angular/common';
import { LangList } from './shareModel';
import { MenuModule } from 'primeng/menu';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HelpPurchasePlanComponent } from './help/help-purchase-plan/help-purchase-plan.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { SummaryComponent } from './layout/summary/summary.component';
import { EventSummaryComponent } from './events/event-summary/event-summary.component';
import { CountdownComponent } from 'ngx-countdown';
import { MacSnManagementComponent } from './setting/mac-sn-management/mac-sn-management.component';
import { CompanionComponent } from './setting/companion/companion.component';
import { ConfirmCompanionComponent } from './setting/confirm-companion/confirm-companion.component';
import { SWSocialLoginComponent } from './login/sw-social-login/sw-social-login.component';
import { SSOComponent } from './login/sso/sso.component';
import { SSOCallbackComponent } from './login/sso-callback/sso-callback.component';
import { MspAdminComponent } from './setting/msp/msp-admin/msp-admin.component';
import { AuthorityMgtComponent } from './setting/msp/authority-mgt/authority-mgt.component';
import { ApiDetailComponent } from './account/api/api-detail/api-detail.component';
import { ApiMgtListComponent } from './setting/api/api-mgt-list/api-mgt-list.component';
import { ApiMgtDetailComponent } from './setting/api/api-mgt-detail/api-mgt-detail.component';
import { HelpMspComponent } from './help/help-msp/help-msp.component';
import { DeviceTransferComponent } from './setting/device/device-transfer/device-transfer.component';
import { ApiDocumentComponent } from './api/api-document.component';
import { LicenseUsedDetailComponent } from './setting/msp/license-used-detail/license-used-detail.component';
import { PaymentMgtListComponent } from './setting/payment/payment-mgt-list/payment-mgt-list.component';
import { PaymentDocumentInfoComponent } from './setting/payment/document-info/document-info.component';
import { PaymentDocumentPdfComponent } from './setting/payment/document-pdf/document-pdf.component';
import { PaymentDocumentDetailComponent } from './setting/payment/document-detail/document-detail.component';
import { UsedDeviceDetailComponent } from './setting/msp/used-device-detail/used-device-detail.component';
import { UsedDeviceHistoryComponent } from './setting/msp/used-device-history/used-device-history.component';
import { GenerateDocumentManuallyComponent } from './setting/payment/generate-document-manually/generate-document-manually.component';
import { APITermsComponent } from './api/api-terms/api-terms.component';
import { GatewayComponent } from './gateway/gateway.component';
import { SNMPProfileComponent } from './gateway/snmp-profile/snmp-profile.component';
import { ConnectionDeviceComponent } from './gateway/connection-device/connection-device.component';
import { AutoDiscoveryComponent } from './gateway/auto-discovery/auto-discovery.component';
import { GatewayMgtListComponent } from './setting/gateway/gateway-mgt-list/gateway-mgt-list.component';
import { MibDetailComponent } from './setting/gateway/mib-detail/mib-detail.component';
import { TrapDetailComponent } from './setting/gateway/trap-detail/trap-detail.component';
import { TokenInterceptor } from './token-interceptor';
import { OverviewComponent } from './setting/msp/overview/overview.component';
import { AdvancedSettingComponent } from './gateway/advanced-setting/advanced-setting.component';
import { GatewayVersionComponent } from './gateway/gateway-version/gateway-version.component';
import { SoftwareModule } from './my-features/software/software.module';
import { HelpGatewayComponent } from './help/help-gateway/help-gateway.component';
import { ProUpgradeComponent } from './setting/msp/pro-upgrade/pro-upgrade.component';
import { ReportListComponent } from './smart-power-report/report-list/report-list.component';
import { ReportPreviewComponent } from './smart-power-report/report-preview/report-preview.component';
import { ReportDetailComponent } from './smart-power-report/report-detail/report-detail.component';
import { ReportListManagementComponent } from './setting/smart-power-report-management/report-list-mgt/report-list-management.component';
import { ReportPreviewManagementComponent } from './setting/smart-power-report-management/report-preview-mgt/report-preview-management.component';
import { ReportDetailManagementComponent } from './setting/smart-power-report-management/report-detail-mgt/report-detail-management.component';
import { BatteryTestResultComponent } from './device/battery-test/battery-test-result/battery-test-result.component';
import { HelpSmartPowerReportComponent } from './help/help-smart-power-report/help-smart-power-report.component';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';

// Import block UI.
const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsPosition: POSITION.bottomCenter,
  bgsSize: 40,
  bgsType: SPINNER.rectangleBounce,
  fgsType: 'rectangle-bounce',
  fgsColor: '#fff',
  pbColor: '#d51f35',
};

// Import get token.
export function tokenGetter() {
  return localStorage.getItem('access_token');
}

// DI - Check login status.
const startupServiceFactory = (startupService: StartupService): Function => () => startupService.load();

// DI - Get log from node.js backend.
const appInitializerFn = (appConfig: AppConfigService) => {
  return () => {
    return appConfig.loadAppConfig();
  };
};

// DI - Import initial translator.
// 💡 Angular 16: TranslateService 在 APP_INITIALIZER 執行時可能還沒準備好
// 暫時移除語言初始化，改在 AppComponent 中處理
const appTranslatorInitializerFactory = (injector: Injector) => {
  return () => Promise.resolve();
};

// Import translator loader http module.
// @ngx-translate/http-loader v8+: TranslateHttpLoader uses Angular DI, no constructor args needed
const createLoader = () => {
  return new TranslateHttpLoader();
};

// Import translator missing handler class, to prevent not find the language.
export class MyMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    if (params.interpolateParams) {
      return params.interpolateParams['Default'] || params.key;
    }
    return params.key;
  }
}


@NgModule({
  declarations: [
    AppComponent,
    IndexRoutingComponents,
    BeforeLoginRoutingComponents,
    DetailRoutingComponents,
    EventsRoutingComponents,
    AlertsRoutingComponents,
    AboutRoutingComponents,
    DeviceRoutingComponents,
    EnergyRoutingComponents,
    OrderRoutingComponents,
    StatusRoutingComponents,
    PackageRoutingComponents,
    LicenseRoutingComponents,
    AdminRoutingComponents,
    HelpRoutingComponents,
    PlanRoutingComponents,
    PaymentRoutingComponents,
    ADirective,
    HelpPurchasePlanComponent,
    SummaryComponent,
    EventSummaryComponent,
    ConfirmCompanionComponent,
    SWSocialLoginComponent,
    SSOComponent,
    SSOCallbackComponent,
    MspAdminComponent,
    AuthorityMgtComponent,
    ApiDetailComponent,
    ApiMgtListComponent,
    ApiMgtDetailComponent,
    HelpMspComponent,
    DeviceTransferComponent,
    ApiDocumentComponent,
    LicenseUsedDetailComponent,
    PaymentMgtListComponent,
    PaymentDocumentInfoComponent,
    PaymentDocumentPdfComponent,
    PaymentDocumentDetailComponent,
    UsedDeviceDetailComponent,
    UsedDeviceHistoryComponent,
    GenerateDocumentManuallyComponent,
    APITermsComponent,
    GatewayComponent,
    SNMPProfileComponent,
    ConnectionDeviceComponent,
    AutoDiscoveryComponent,
    GatewayMgtListComponent,
    MibDetailComponent,
    TrapDetailComponent,
    OverviewComponent,
    AdvancedSettingComponent,
    GatewayVersionComponent,
    HelpGatewayComponent,
    ProUpgradeComponent,
    ReportListComponent,
    ReportPreviewComponent,
    ReportDetailComponent,
    ReportListManagementComponent,
    ReportPreviewManagementComponent,
    ReportDetailManagementComponent,
    BatteryTestResultComponent,

    HelpSmartPowerReportComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: TranslateHttpLoader
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: MyMissingTranslationHandler
      }
    }),
    StoreModule.forRoot(fromStore.reducers, { metaReducers: [clearState] }),
    EffectsModule.forRoot(fromStore.effects),
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    AppRoutingModule,
    ShareModule,
    UserModule,
    !environment.production ? StoreRouterConnectingModule.forRoot() : [],
    !environment.production ? StoreDevtoolsModule.instrument({ maxAge: 50 }) : [],
    // 2024/10/08 kyrie: 移除call API時 代入的JWT Header (access_token)
    // JwtModule.forRoot({
    //   config: {
    //     tokenGetter: tokenGetter,
    //     whitelistedDomains: ['localhost', environment.apiDomain]
    //   }
    // }),
    // Main Component Module
    ModuleModule,
    NodeModule,
    RegionModule,
    UpdateInfoModule,
    StatusModule,
    AccountModule,
    FloorMapModule,
    ChangeInfoModule,
    PurchaseModule,
    LicenseMgtModule,
    DeviceMgtModule,
    DeviceModule,
    allAccount.AccountModule,
    CheckLicenseModule,
    ActivateLicenseModule,
    StopLicenseModule,
    FirmWareModule,
    PrivacyAndTermsModule,
    EventMonitoringModule,
    DeviceMonitoringModule,
    BatteryTestModule,
    BatteryReplacementModule,
    BindDeviceModule,
    WorldMapModule,
    PlanModule,
    MenuModule,
    ActivateTrialLicenseModule,
    NotificationModule,
    ContactUsModule,
    AzureBlobStorageModule,
    DeviceSharingModule,
    UserActivityLogModule,
    AppDownloadModule,
    NgbModule,
    PriceModule,
    SummaryModule,
    NgApexchartsModule,
    CountdownComponent,
    OauthModule,
    AuthOTPModule,
    DeviceResetModule,
    SystemlogModule,
    CompanionModule,
    CompanionRuleModule,
    DeviceSettingModule,
    GroupSharingModule,
    ApiKeyModule,
    GateWayModule,
    SoftwareModule,
    ProModule,
    SmartPowerReportModule,
    MailModule,
    DeviceUPSControlModule,
    EventMapModule,
    HardwareModule
  ],
  providers: [
    AuthGuard, 
    MessageService, 
    Title, 
    AutoLogoutService, 
    LanguageService,
    StartupService, // 💡 確保 Service 本身有被列出
    AppConfigService, // 💡 確保 Service 本身有被列出
    WINDOW_PROVIDERS,
  {
    provide: APP_INITIALIZER,
    useFactory: startupServiceFactory,
    deps: [StartupService, Injector], // 👈 檢查 StartupService 內部有沒有用到 Actions
    multi: true
  },
  {
    provide: APP_INITIALIZER,
    useFactory: appInitializerFn,
    deps: [AppConfigService],
    multi: true
  },
  {
    provide: APP_INITIALIZER,
    useFactory: appTranslatorInitializerFactory,
    deps: [Injector],
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptor,
    multi: true
  },
  // @ngx-translate/http-loader v17+ 需要明確提供 TRANSLATE_HTTP_LOADER_CONFIG token
  {
    provide: TRANSLATE_HTTP_LOADER_CONFIG,
    useValue: {}  // 使用預設值 (prefix: /assets/i18n/, suffix: .json)
  },
  providePrimeNG({ 
        theme: {
            preset: Aura,
            // 停用 PrimeNG 內建的「跟隨系統深色模式」自動切換 (預設會依 prefers-color-scheme 產生深色樣式)
            // 避免使用者瀏覽器/系統為深色模式時，輸入框等元件被套用深色配色而看不清楚
            options: {
                darkModeSelector: false
            }
        }
    })
],
  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule { }
